
// Libraries
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

// CSS
import 'semantic-ui-css/semantic.min.css'

// Redux root node for the state tree
import root from './reducers/root'

// Main application
//import LibraryApp from './components/app/LibraryApp'
import App from './containers/app/App'

// Api refs to set store
import AppUtils from './utils/AppUtils'

// Create redux store
AppUtils.store = createStore(
  root,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(thunk)
)

// Render react main component
render(
  <Provider store={AppUtils.store}>
    <App />
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js